import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { ApiServiceService } from '../../services/api-service.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-my-modal',
  templateUrl: './my-modal.component.html',
  styleUrl: './my-modal.component.scss'
})
export class MyModalComponent {
  addressData: any;
  addressId: any;


  constructor( private router:Router,public dialogRef: MatDialogRef<MyModalComponent> , private api:ApiServiceService, 
    private activeroute:ActivatedRoute,
    private toastr: ToastrService) {}


  ngOnInit() {
    this.getAllUserAddress();
    
    }
    
  getAllUserAddress(){
    this.api.getAllUserAddress().subscribe((allAddress: any)=>{
      this.addressData = allAddress.data;    
    })
  }


deleteAddress(addressId: string) {
  if (!addressId) {
    this.toastr.error('Invalid address ID');
    return;
  }

  this.api.deleteAddressById(addressId).subscribe({
    next: (response) => {
      this.toastr.success(response.message);
      this.getAllUserAddress(); // Refresh the address list after deletion
    },
    error: (error) => {
      console.error('Error deleting address:', error);
      this.toastr.error(error?.error?.message || 'Failed to delete address');
    }
  });
}


  onNoClick(): void {
    this.dialogRef.close();
   
  }


  editAddress(addressId:any){
    this.router.navigate(["add-Address",addressId])
    this.dialogRef.close();
  }


  addressUpdate(){
   
    this.router.navigate(["/add-address"]);
    this.dialogRef.close();
  }
  onSelect() {
  
    this.dialogRef.close();

  }
  
  setDefaultAddress() {
    if (!this.addressId) {
      this.toastr.error('Please select a valid address.');
      return;
    }
  
    this.api.setDefaultAddress(this.addressId).subscribe({
      next: (res: any) => {
        this.toastr.success(res?.message || 'Default address set successfully.');
      },
      error: (error) => {
        console.error('Error setting default address:', error);
        this.toastr.error(error?.error?.message || 'Failed to set default address.');
      }
    });
  }
  

  selectAddress(address_id: any){
    this.addressId = address_id
  }

}

